module.exports = __webpack_public_path__ + "assets/images/twitter.f92b452d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/social-media/twitter.svg
// module id = 347
// module chunks = 1